//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SimpleImageTextLeft',
  props: {
    section: {
      type: Object
    },
    roundType: {
      type: String,
      default: 'none'
    }
  }
}
